import axios from 'axios';
import * as URLS from '@/config/urls';
import * as CONFIG from "@/config/config";
import store from "@/store";
import md5 from 'crypto-js/md5';
import {SERVICES_TYPES} from "@/config/urls";

export const checkSecurityToken = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = `${URLS.API_URL}${URLS.CHECK_API}`;

		const requestData = {
			securityToken: data.securityToken
		};

		axios
			.get(`${queryUrl}`, {
				params: requestData
			})
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export const servicesTypes = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = `${URLS.API_URL}${URLS.SERVICES_TYPES}`;

		const requestData = {
			securityToken: data.securityToken
		};

		axios
			.get(`${queryUrl}`, {
				params: requestData
			})
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}


export const login = function () {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = `${URLS.API_URL}${URLS.LOGIN}`;

		axios
			.get(`${queryUrl}`, {
				params: {
					appVersion: 1,
					company: "Vonigo",
					password: CONFIG.USER_PWD_HASH,
					userName: CONFIG.USER_LOGIN
				}
			})
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export const findExistingContactByEmail = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const requestData = {
			securityToken: data.securityToken,
			searchPar: data.email,
			isCompleteObject: 'true',
		};
		const queryUrl = `${URLS.API_URL}${URLS.CONTACT}`;
		axios
			.get(`${queryUrl}`, { params: requestData })
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export const setResetPasswordKey = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = `${URLS.API_URL}${URLS.CONTACT}`;

		const requestData = {
			securityToken: data.securityToken,
			method: 10,
			objectID: data.contactId,
		};

		axios
			.get(`${queryUrl}`, { params: requestData })
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export const validateResetPasswordKey = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = `${URLS.API_URL}${URLS.CONTACT}`;

		const requestData = {
			securityToken: data.securityToken,
			method: 11,
			objectID: data.contactId,
			resetKey: data.resetKey,
		};
		axios
			.get(`${queryUrl}`, { params: requestData })
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export const setPassword = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = `${URLS.API_URL}${URLS.CONTACT}`;

		const password = (md5(data.password)).toString();

		const requestData = {
			securityToken: data.securityToken,
			method: 8,
			objectID: data.contactId,
			clientID: data.clientId,
			userName: data.login,
			password,
		};

		axios
			.post(`${queryUrl}`, requestData, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export const getClientByContactId = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = `${URLS.API_URL}${URLS.CONTACT}`;

		const requestData = {
			securityToken: data.securityToken,
			method: 1,
			objectID: data.contactId,
			isCompleteObject: 'true',
		};

		axios
			.post(`${queryUrl}`, requestData, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export const getClient = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = `${URLS.API_URL}${URLS.CLIENTS}`;

		const requestData = {
			securityToken: data.securityToken,
			method: 1,
			objectID: data.clientId,
		};
		axios
			.get(`${queryUrl}`, { params: requestData })
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export const findContactByPhone = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = `${URLS.API_URL}${URLS.CONTACT}`;

		const requestData = {
			securityToken: data.securityToken,
			method: 0,
			pageNo: 1,
			pageSize: 1,
			sortMode: 1,
			sortDirection: 1,
			isCompleteObject: 'true',
			searchPar: data.phone
		};
		axios
			.get(`${queryUrl}`, { params: requestData })
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export const findLocationByClient = function (data: any) {
	return new Promise<any>((resolve, reject) => {
		const queryUrl = `${URLS.API_URL}${URLS.LOCATION}`;

		const requestData = {
			securityToken: data.securityToken,
			clientID: data.clientID,
		};
		axios
			.get(`${queryUrl}`, { params: requestData })
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export const createClient = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = `${URLS.API_URL}${URLS.CLIENTS}`;

		const requestData = {
			securityToken: data.securityToken,
			method: data.method,
			Fields: [
				{
					fieldID: 1091, //// Email
					fieldValue: data.email
				},
				{
					fieldID: 121,
					optionID: 59 // 59 - residential, 60 - commercial
				},
				{
					fieldID: 126, // account name (full name?)
					fieldValue: data.fullName
				},
				{
					fieldID: 112,
					fieldValue: data.phoneNumber//phoneNumber
				},
			]
		};
		if(data.method == 2){
			//@ts-ignore
			requestData.objectID = data.objectID
		}
		axios
			.post(`${queryUrl}`, requestData, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export const createContact = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = `${URLS.API_URL}${URLS.CONTACT}`;

		const requestData = {
			securityToken: data.securityToken,
			method: data.method,
			Fields:
				[
					{
						"fieldID": 1088,
						"fieldValue": data.phone
					},
					{
						"fieldID": 97,
						"fieldValue": data.email
					},
					{
						"fieldID": 127,
						"fieldValue": data.firstName
					},
					{
						"fieldID": 9795,
						"fieldValue": data.fullName
					},
					{
						"fieldID": 128,
						"fieldValue": data.lastName
					}
				]
		};
		if(+data.method === 2) {
			//@ts-ignore
			requestData.objectID = data.objectID
		}
		else if (+data.method === 3){
			//@ts-ignore
			requestData.clientID = data.objectID
		}
		axios
			.post(`${queryUrl}`, requestData, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export const saveLocation = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = `${URLS.API_URL}${URLS.LOCATION}`;

		const requestData = {
			securityToken: data.securityToken,
			method: data.method,
			Fields:
				[
					{
						"fieldID": 779,
						"optionID": data.country

					},
					{
						"fieldID": 778,
						"optionID": data.state

					},
					{
						"fieldID": 776,
						"fieldValue": data.city

					},
					{
						"fieldID": 773,
						"fieldValue": data.address
					},
					{
						"fieldID": 775,
						"fieldValue": data.zip
					}
				]
		};
		if(+data.method === 2) {
			//@ts-ignore
			requestData.objectID = data.objectID
		}
		else if (+data.method === 3){
			//@ts-ignore
			requestData.clientID = data.objectID
		}
		axios
			.post(`${queryUrl}`, requestData, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export const createJob = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = `${URLS.API_URL}${URLS.JOB}`;

		const requestData = {
			securityToken: data.securityToken,
			method: 3,
			clientID: data.clientId,
			promoID: data.promoID,
			Fields: [
				{
					fieldID: 968,
					fieldValue: data.promotion // Promotion
				},
				{
					fieldID: 978,
					fieldValue: data.summary // Jobs Summary
				},
				{
					fieldID: 982,
					optionID: 11 // Service Type
				}
			]
		};
		axios
			.post(`${queryUrl}`, requestData, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}


export const createWorkOrder = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = `${URLS.API_URL}${URLS.WORK_ORDER}`;

		const requestData = {
			securityToken: data.securityToken,
			method: 3,
			jobID: data.jobID,
			lockID: data.lockID,
			clientID: data.clientID,
			contactID: data.contactID,
			locationID: data.locationID,
			serviceTypeID: 11,
			Fields: data.Fields.concat([
				{
					fieldID: 186,
					fieldValue: 60
				},
				{
					fieldID: 200,
					fieldValue: data.description
				},
				{
					fieldID: 201, // Label
					optionID: 9996
				},
				{
					fieldID: 10594,
					optionID: 10366
				}
			]),
		};
		if (data.charges && data.charges.length !== 0) {
			//@ts-ignore
			requestData.Charges  = JSON.parse(JSON.stringify(data.charges))
		}
		axios
			.post(`${queryUrl}`, requestData, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export const checkPromotion = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = `${URLS.API_URL}${URLS.CHECK_PROMOTION}`;

		const requestData = {
			securityToken: data.securityToken,
			method: 1,
			promo: data.promo,
		};
		axios
			.post(`${queryUrl}`, requestData, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export const getOptions = function (securityToken: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = `${URLS.API_URL}${URLS.OBJECTS}`;

		const requestData = {
			securityToken: securityToken,
			method: 1,
			objectID: 12,
		};

		axios
			.post(`${queryUrl}`, requestData, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}








